import Vue from "vue";
import App from "./App.vue";
import VueRouter from "vue-router";
import { store } from "./store";
import Home from "./components/ExhibitorList";
import DetailPage from "./components/ExhibitorProfile/ExhibitorProfile";

Vue.config.productionTip = false;
Vue.use(VueRouter);
const routes = [
  {
    name: "home",
    path: "/conference/strategic-summit/agenda",
    component: Home
  },
  {
    name: "home",
    path: "/conferences/technical-conference/technical-agenda/",
    component: Home
  },
  {
    name: "home",
    path: "/conferences/gastech-conference-program/",
    component: Home
  },
  {
    name: "home",
    path: "/conferences/strategic-conference/strategic-agenda/",
    component: Home
  },
  {
    name: "home",
    path: "/conferences/strategic-conference/strategic-conference-programme/",
    component: Home
  },
  {
    name: "home",
    path: "/conferences/technical-conference/technical-conference-programme/",
    component: Home
  },
  {
    name: "home",
    path: "/conferences/technical-conference/2024-technical-conference-programme/",
    component: Home
  },
  {
    name: "ExhibitorDetails",
    path: "/exhibitordetails",
    component: DetailPage
  }
];


const router = new VueRouter({
  mode: "history",
  routes
});

new Vue({
  store,
  router,
  render: h => h(App)
}).$mount("#app");
